import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Requests from './pages/Requests';
import Events from './pages/Events';
import Volunteers from './pages/Volunteers';
import Admin from './pages/Admin';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => { setUser(u); setLoading(false); });
    return unsub;
  }, []);

  if (loading) return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#F0FDF4'}}>
      <div style={{textAlign:'center'}}>
        <div style={{fontSize:'48px',marginBottom:'16px'}}>🏘</div>
        <p style={{color:'#166534',fontWeight:600}}>Loading CommunityBridge...</p>
      </div>
    </div>
  );

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing user={user}/>}/>
        <Route path="/login" element={!user ? <Login/> : <Navigate to="/dashboard"/>}/>
        <Route path="/signup" element={!user ? <Signup/> : <Navigate to="/onboarding"/>}/>
        <Route path="/onboarding" element={user ? <Onboarding user={user}/> : <Navigate to="/login"/>}/>
        <Route path="/dashboard" element={user ? <Dashboard user={user}/> : <Navigate to="/login"/>}/>
        <Route path="/requests" element={user ? <Requests user={user}/> : <Navigate to="/login"/>}/>
        <Route path="/events" element={user ? <Events user={user}/> : <Navigate to="/login"/>}/>
        <Route path="/volunteers" element={user ? <Volunteers user={user}/> : <Navigate to="/login"/>}/>
        <Route path="/admin" element={user ? <Admin user={user}/> : <Navigate to="/login"/>}/>
      </Routes>
    </Router>
  );
}

export default App;
